import { withInstall } from '@ll-plus/utils'

import TimeRange from './src/time-range.vue'

export const LlTimeRange = withInstall(TimeRange)
export default LlTimeRange
export * from './src/time-range'

declare module 'vue' {
  export interface GlobalComponents {
    LlTimeRange: typeof TimeRange
  }
}
